"use strict";
var Promise = require("promise");
var global = require("global");
var ReactNative = require("react-native");
var Image = ReactNative.Image;
var Platform = ReactNative.Platform;

module.exports = loadImage;

function loadImage(image) {
	if(image.type && image.type.indexOf("image") === -1) return Promise.resolve(null);
	if(!isWeb()) return getSized(image);
	return loadFileWeb(image).then(getSized);
}

function loadFileWeb(image) {
	return new Promise(function (resolve, reject) {
		if ( image.isCordova) {
			return resolve({
				uri: image.url
			});
		}
		var FileReader = global.FileReader;
		var reader = new FileReader();
		reader.onload = function(){
			var result = reader.result;
			resolve({
				uri: result
			});
		}.bind(this);
		reader.readAsDataURL(image);
		reader.onerror = reject;
	});
}

function getSized(image) {
	var uri = image.uri;

	return new Promise(function(resolve, reject){
		Image.getSize(uri, function(width, height){
			resolve({
				image: image,
				width: width,
				height: height
			});
		}, reject);
	});
}

function isWeb() {
	return Platform.OS === "web";
}